import React from "react";
import { inject, observer } from "mobx-react";
import ngeGameActionOptions from "../constants/ngeGameActionOptions";
import GameActionsDropDown from "../components/GameActionsDropDown";

class NGEGameActionDropDownContainer extends React.Component {
  render() {
    const { NGEGameActionStore } = this.props.rootStore;

    return (
      <GameActionsDropDown
        game={this.props.game}
        gameActionOptions={ngeGameActionOptions}
        transitionToCreateIncident={
          NGEGameActionStore.trackingAccuracyReportSource
            .transitionToCreateIncident
        }
        clearClippyCache={NGEGameActionStore.clearClippyCache}
        clearStatsApiCache={NGEGameActionStore.clearStatsApiCache}
        resendGame={NGEGameActionStore.resendGame}
      />
    );
  }
}

export default inject("rootStore")(observer(NGEGameActionDropDownContainer));
